export default __webpack_public_path__ + "static/IP_Vision_Pro_05-c0b3acd5adda80bf082da3a6a17c07b4.webp";